import { useEffect, useRef, useState, type ReactNode } from 'react';
import { STATUS_RU } from './api';

export function Tile({ label, value, sub, tone }: { label: string; value: ReactNode; sub?: ReactNode; tone?: 'debt' | 'prepaid' }) {
  return (
    <div className="tile">
      <div className="label">{label}</div>
      <div className="value" style={{ color: tone === 'debt' ? 'var(--red)' : tone === 'prepaid' ? 'var(--green)' : undefined }}>
        {value}
      </div>
      {sub ? <div className="sub">{sub}</div> : null}
    </div>
  );
}

const STATUS_TONE: Record<string, string> = {
  NEW: '',
  PLANNED: 'blue',
  IN_ROUTE: 'amber',
  DELIVERED: 'green',
  DONE: 'green',
  PARTIAL: 'amber',
  FAILED: 'red',
  CANCELED: 'red',
  ACTIVE: 'blue',
  CLOSED: 'green',
};

export function Status({ value }: { value: string }) {
  return <span className={`badge ${STATUS_TONE[value] ?? ''}`}>{STATUS_RU[value] ?? value}</span>;
}

export function Loading({ what = 'Загружаю' }: { what?: string }) {
  return <div className="muted" style={{ padding: 20 }}>{what}…</div>;
}

export function ErrorBox({ error }: { error: unknown }) {
  if (!error) return null;
  const msg = error instanceof Error ? error.message : String(error);
  return <div className="err">{msg}</div>;
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="muted" style={{ padding: '24px 8px', textAlign: 'center' }}>{children}</div>;
}

/** Короткое сообщение об успехе действия. Само гаснет — чтобы не мешало. */
export function useToast() {
  const [msg, setMsg] = useState<string | null>(null);
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const show = (text: string, ms = 2500) => {
    setMsg(text);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setMsg(null), ms);
  };
  const node = msg ? <div className="toast">{msg}</div> : null;
  return { show, node };
}

/** Счётчик «минус / число / плюс» — единственный способ ввода на ходу. */
export function Counter({
  value,
  onChange,
  min = 0,
  max = 99,
  label,
}: {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max?: number;
  label?: string;
}) {
  return (
    <div>
      {label ? <label>{label}</label> : null}
      <div className="counter">
        <button type="button" onClick={() => onChange(Math.max(min, value - 1))} disabled={value <= min}>
          −
        </button>
        <div className="val">{value}</div>
        <button type="button" onClick={() => onChange(Math.min(max, value + 1))} disabled={value >= max}>
          +
        </button>
      </div>
    </div>
  );
}
